<template>
  <div>
    <expansion-panel
      name="rotation"
      ref="ztExpansionPanelRotation"
      :title="$t('message.abm.folders.toolbox.rotate')"
      class="mb-4"
      prepend-icon="circle-arrow-outline"
      :disabled="disabled"
      :auto-collapse="false"
      :focus-active="false"
    >
      <div class="">
        <p class="text-zt-dark-300 mb-4 font-125">{{ $t('message.abm.folders.toolbox.rotation') }}</p>
        <zt-button
          @click="rotatePDF(270)"
          icon="circle-arrow-outline"
          class="w-full mb-3"
          style="justify-content: flex-start; height: 49px;"
          outlined
          icon-after
          data-vs-button="rotatePDF"
        >
          {{ $t('message.abm.folders.toolbox.leftDir') }}
        </zt-button>
        <zt-button @click="rotatePDF(90)"
          icon="circle-arrow-outline"
          class="w-full mb-4 flip"
          style="justify-content: flex-start; height: 49px;"
          outlined
          icon-after
          data-vs-button="rotatePDF"
        >
          {{ $t('message.abm.folders.toolbox.rightDir') }}
        </zt-button>
        <p
          v-if="isModified"
          @click="activeDeleteBox"
          class="text-zt-dark-400 mt-2 underline cursor-pointer inline-block"
          ref="linkReverseRotation"
          data-vs-button="activeDeleteBox"
        >
          {{ $t('message.abm.folders.toolbox.undo') }}
        </p>
        <div
          v-show="showDeleteBox"
          ref="warningDeleteBox"
          class="absolute bg-white rounded position-box box-deleted p-4 flex flex-column"
          :style="cordsDeleteBox"
        >
          <p class="font-medium mb-3">{{ $t('message.abm.folders.toolbox.undoTitle') }}</p>
          <p class="text-zt-dark-300 text-zt-base">
            {{ $t('message.abm.folders.toolbox.undoRotation') }}
          </p>
          <div class="flex justify-end h-full items-end">
            <zt-button text style="color: #4a4a4a !important;" class="text-zt-base" @click="closeBoxDelete" data-vs-button="closeBoxDelete">
              {{ $t('message.abm.folders.toolbox.cancel') }}
            </zt-button>
            <zt-button class="text-zt-base ml-2" @click="clearRotation" data-vs-button="clearRotation">
              {{ $t('message.abm.folders.toolbox.confirmUndo') }}
            </zt-button>
          </div>
        </div>
      </div>
    </expansion-panel>
  </div>
</template>
<script>
import ExpansionPanel from '../generic/ExpansionPanel'
export default {
name: "RotatePdfActionPanel",
  inject: [
    'modalState',
    'setFocusPanel',
    'setModalStateProperty',
    'signatureState',
    'signatureToolApplied',
    'updateVisorPDF'
  ],
  components: {
    ExpansionPanel
  },
  data() {
    return  {
      applied: false,
      cordsDeleteBox: {},
      rotationPDF: 0,
      rotationIncrease: 90,
      showDeleteBox: false
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: true
    },
    noFocusPanel: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isModified() {
      return this.rotationPDF > 0 || this.applied
    }
  },
  watch: {
    showDeleteBox() {
      if (this.showDeleteBox) {
        this.insertContent(this.$refs.warningDeleteBox)
      }
    },
    rotationInit(newValue) {
      this.rotationPDF = newValue
    }
  },
  methods: {
    activeDeleteBox() {
      this.showDeleteBox = true
      this.$nextTick(() => {
        this.cordsDeleteBox = this.positionBox()
      })
    },
    clearRotation() {
      this.rotationPDF = 0
      this.closeBoxDelete()
      this.$emit('clear', 'rotation')
    },
    close() {
      this.$refs.ztExpansionPanelRotation.close()
    },
    closeBoxDelete() {
      this.showDeleteBox = false
      this.deleteContent()
    },
    deleteContent() {
      let [parent] = document.getElementsByTagName('body')
      if (
        parent &&
        this.$refs.warningDeleteBox &&
        this.$refs.warningDeleteBox.parentNode === parent
      ) {
        parent.removeChild(this.$refs.warningDeleteBox)
      }
    },
    insertContent(elz) {
      let content = document.body
      content.insertBefore(elz, content.firstChild)
    },
    positionBox() {
      let linkReverse = this.$refs['linkReverseRotation']
      let scrollContentTop = window.pageYOffset || document.documentElement.scrollTop
      let topPos = linkReverse.getBoundingClientRect().top
          + scrollContentTop - linkReverse.clientHeight - 12
      let leftPost = linkReverse.getBoundingClientRect().right + 12
      return {
        left: `${leftPost}px`,
        top: `${topPos}px`
      }
    },
    rotatePDF(rotationValue) {
      if (this.modalState.config.rotationApplied) return
      this.rotationPDF += rotationValue
      const rotation = this.rotationPDF % 360
      this.updateVisorPDF({ rotation, rotationPending: true  })
      this.signatureToolApplied( rotation > 0, 'rotatePdf')
    },
  },
  beforeDestroy() {
    this.deleteContent()
  }
}
</script>
<style scoped lang="scss">
::v-deep .flip {
  .zt-icon {
    transform: scaleX(-1)
  }
}
.position-box {
  width: 350px;
  height: 176px;
  z-index: 9999;
  box-shadow: 0 0 10px 0 rgba(44, 43, 43, 0.65);
  -webkit-box-shadow: 0 0 10px 0 rgba(44, 43, 43, 0.65);
  -moz-box-shadow: 0 0 10px 0 rgba(44, 43, 43, 0.65);
}
.box-deleted:after {
  content: "";
  background: inherit;
  width: 16px;
  height: 16px;
  position: absolute;
  display: block;
  left: -14px;
  transform: rotate(45deg) translateY(-50%);
  top: 25%;
  border-left: 1px solid #D0D0D0FF;
  border-bottom: 1px solid #D0D0D0FF;
}
</style>
